import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Dialog, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormInput } from 'components';

import styles from './PaymentMethodPopup.module.scss';

type PaymentMethodPopupProps = {
  open: boolean;
  close: () => void;
};

type PaymentMethodProps = {
  CardHolderName: string;
  cardNumber: string;
  ExpirationDate: string;
  CVV: string;
};

export const PaymentMethodPopup = (props: PaymentMethodPopupProps) => {
  const { t } = useTranslation('settings');

  const schema = Yup.object().shape({
    CardHolderName: Yup.string().required(t('paymentMethodPopup.cardHolderNameRequired')),
    CardNumber: Yup.string().required(t('paymentMethodPopup.cardNumberRequired')),
    ExpirationDate: Yup.string().required(t('paymentMethodPopup.expirationDateRequired')),
    CVV: Yup.string().required(t('paymentMethodPopup.cvvRequired')),
  });

  const form = useForm<PaymentMethodProps>({
    resolver: yupResolver(schema),
    defaultValues: {},
    mode: 'all',
  });

  return (
    <Box>
      <Dialog sx={{ '& .MuiPaper-root': { padding: '20px', width: '40rem' } }} open={props.open} onClose={props.close}>
        <Box className={styles.password_popup_header_box}>
          <Typography variant='body2' className={styles.password_main_title}>
            {t('paymentMethodPopup.title')}
          </Typography>
          <CloseIcon onClick={props.close} className={styles.closeIcon} />
        </Box>
        <Box>
          <Typography variant='body2' className={styles.typography}>
            {t('paymentMethodPopup.cardHolderName')} <span className={styles.asterisk}>*</span>
          </Typography>
          <FormInput name='CardHolderName' control={form.control} type='text' />
        </Box>
        <Box>
          <Typography variant='body2' className={styles.typography}>
            {t('paymentMethodPopup.cardNumber')} <span className={styles.asterisk}>*</span>
          </Typography>
          <FormInput name='CardNumber' control={form.control} type='text' />
        </Box>
        <Box className={styles.flexContainer}>
          <Box>
            <Typography variant='body2' className={styles.typography}>
              {t('paymentMethodPopup.expirationDate')} <span className={styles.asterisk}>*</span>
            </Typography>
            <FormInput name='ExpirationDate' control={form.control} type='text' />
          </Box>
          <Box>
            <Typography variant='body2' className={styles.typography}>
              {t('paymentMethodPopup.cvv')} <span className={styles.asterisk}>*</span>
            </Typography>
            <FormInput name='CVV' control={form.control} type='text' />
          </Box>
        </Box>
        <Button variant='contained' className={styles.button}>
          {t('paymentMethodPopup.addPaymentMethod')}
        </Button>
      </Dialog>
    </Box>
  );
};
